import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import "../style.scss";
import { Translate } from "../../../../Enums/Tranlate";
import DesignationsService from "../../../../../services/HRM/DesignationsService";
import BranchesService from "../../../../../services/Company/BranchesService";
import ScrollPagination from "../../../../common/ScrollPagination";

const AddDesignationModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	type,
	Service,
}) => {
	const [formData, setFormData] = useState({
		title: "",
		branchId: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const designationsService = new DesignationsService();

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				designation: item?.title,
				branchId: {
					label: item?.branchName,
					value: item?.branchId,
				},
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			title: formData.designation,
			branchId: formData?.branchId?.value,
		};

		setLoading(true);
		if (isAdd) {
			designationsService
				.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`Designation Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			designationsService
				.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`Designation Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.designation}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={12}>
							<AvField
								label={Translate[lang]?.designation}
								type="text"
								placeholder={Translate[lang]?.designation}
								bsSize="lg"
								name="designation"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.designation}
								onChange={(e) =>
									setFormData({ ...formData, designation: e.target.value })
								}
							/>
						</Col>
						<Col md={12}>
							<label className="text-label">
								{Translate[lang]?.department}
							</label>
							<ScrollPagination
								Service={new BranchesService()}
								value={formData?.branchId}
								nameVal="name"
								setData={(e) =>
									setFormData((prev) => ({ ...prev, branchId: e }))
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.designation}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddDesignationModal;
